<template>
  <div :class="$style.container">
    <SettingsPagePanel>
      <SettingsPagePanelHeader>
        <template #title>アクセスコントロール作成</template>
        <template #right>
          <FlatButton
            variant="primary"
            size="medium"
            @click="handleSave"
            :disabled="isButtonDisabled"
          >
            保存
          </FlatButton>
        </template>
      </SettingsPagePanelHeader>
      <SettingsPageAuthzPolicyForm v-model="form" />
    </SettingsPagePanel>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { captureException } from '@sentry/vue'

import { useAlert } from '@/libs/alertPortal'
import FlatButton from '@/components/atoms/FlatButton.vue'

import SettingsPageAuthzPolicyForm, {
  formatToGQLInput,
  type AuthzPolicyForm,
} from './Form/SettingsPageAuthzPolicyForm.vue'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { useCreateAuthzPolicyMutation } from './SettingsPageAuthzPolicyCreateView.generated'

const alert = useAlert()
const router = useRouter()

const { mutate } = useCreateAuthzPolicyMutation()

const form = ref<AuthzPolicyForm>({
  name: '',
  effect: 'PERMIT',
  principal: {
    type: 'AnyAuthzPolicyPrincipal',
  },
  action: {
    type: 'AnyAuthzPolicyAction',
  },
  resource: {
    type: 'AnyAuthzPolicyResource',
  },
})

const isSaving = ref(false)
const isButtonDisabled = computed(() => {
  // TODO: formがvalidかどうかの判定を追加する
  return isSaving.value
})

const handleSave = async () => {
  isSaving.value = true

  const input = {
    ...formatToGQLInput(form.value),
  }

  await mutate({ input })
    .then(() => {
      // eslint-disable-next-line fp/no-mutating-methods
      router.push({
        name: 'authzPolicySetting',
      })
    })
    .catch(e => {
      captureException(e)
      alert.error(
        'エラーが発生しました。再度お試しいただくか、サポートにお問い合わせください。'
      )
    })
    .finally(() => {
      isSaving.value = false
    })
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
